module.exports = __webpack_public_path__ + "img/Get-Started@2x.5c3a1c47.png";